'use strict';

var jsxRuntime = require('@emotion/react/jsx-runtime');
var react = require('@emotion/react');
var index = require('../../../aviary-core/dist/cjs/index.cjs');

/**
 * SVG Illustration of cart
 */ const Cart = ({ assetColor = index.ASSET_COLORS.grey, size = index.ILLUSTRATION_DIMENSIONS.medium, ...rest })=>{
    const theme = react.useTheme();
    return /*#__PURE__*/ jsxRuntime.jsxs("svg", {
        width: size,
        height: size,
        viewBox: "0 0 104 105",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        ...rest,
        children: [
            /*#__PURE__*/ jsxRuntime.jsx("circle", {
                cx: "52",
                cy: "52.252",
                r: "52",
                fill: theme.ds5.asset[assetColor].background
            }),
            /*#__PURE__*/ jsxRuntime.jsx("path", {
                d: "M39.579 62.687L32.9144 32.7052C32.5181 30.9207 31.5145 29.3079 30.0879 28.1645C28.6622 27.0202 26.8705 26.3906 25.0423 26.3906H18.5647C17.8434 26.3906 17.3082 27.0576 17.4649 27.7611L18.4667 32.2671C18.5861 32.805 19.0634 33.1888 19.6155 33.1888H25.0432C25.6407 33.1888 26.1492 33.5966 26.2783 34.1799L32.9429 64.1616C33.2946 65.7459 34.6999 66.8243 36.2583 66.8243C36.5023 66.8243 36.7507 66.7976 36.9992 66.7423C38.8318 66.3354 39.9868 64.5187 39.5799 62.687H39.579Z",
                fill: theme.ds5.asset[assetColor]["100"]
            }),
            /*#__PURE__*/ jsxRuntime.jsx("path", {
                d: "M59.0856 29.7234V26.5109C60.3629 26.5109 61.3984 25.4754 61.3984 24.198V23.4703C61.3984 21.791 60.0371 20.4297 58.3578 20.4297H43.2432C41.5639 20.4297 40.2026 21.791 40.2026 23.4703V24.198C40.2026 25.4754 41.2381 26.5109 42.5154 26.5109V29.7708C41.2463 30.2343 40.1519 31.0681 39.379 32.1602C38.6061 33.2523 38.1917 34.5506 38.1914 35.8807V55.4171C38.1914 57.425 39.8191 59.0527 41.8271 59.0527H59.9137C61.9217 59.0527 63.5494 57.425 63.5494 55.4171V35.8836C63.5494 34.5284 63.1194 33.2069 62.3194 32.1029C61.5194 30.9988 60.3891 30.1671 59.0856 29.7234Z",
                fill: theme.ds5.asset[assetColor].backItem
            }),
            /*#__PURE__*/ jsxRuntime.jsx("path", {
                d: "M75.2624 34.9991V32.2267C76.3648 32.2267 77.2585 31.333 77.2585 30.2307V29.6026C77.2585 28.1534 76.0836 26.9785 74.6344 26.9785H61.5902C60.141 26.9785 58.9661 28.1534 58.9661 29.6026V30.2307C58.9661 31.333 59.8598 32.2267 60.9622 32.2267V35.04C59.8669 35.4401 58.9224 36.1596 58.2553 37.1021C57.5883 38.0446 57.2307 39.165 57.2305 40.3129V56.6751C57.2305 58.683 58.8582 60.3107 60.8661 60.3107H75.4791C77.487 60.3107 79.1148 58.683 79.1148 56.6751V40.3155C79.1147 39.1459 78.7437 38.0055 78.0533 37.0526C77.3629 36.0998 76.3874 35.3821 75.2624 34.9991Z",
                fill: theme.ds5.asset[assetColor]["400"]
            }),
            /*#__PURE__*/ jsxRuntime.jsx("rect", {
                x: "40.0039",
                y: "20.4219",
                width: "21.5417",
                height: "5.97374",
                rx: "1.11005",
                fill: theme.ds5.asset[assetColor]["600"]
            }),
            /*#__PURE__*/ jsxRuntime.jsx("rect", {
                x: "58.6211",
                y: "27.0332",
                width: "18.9364",
                height: "5.4104",
                rx: "1.11005",
                fill: theme.ds5.asset[assetColor]["600"]
            }),
            /*#__PURE__*/ jsxRuntime.jsx("path", {
                d: "M40.1638 71.2679H73.2009C74.5002 71.2679 75.6142 70.3409 75.8493 69.063L80.707 42.6914H31.6523L37.5351 69.1592C37.8093 70.3908 38.902 71.2679 40.1638 71.2679Z",
                fill: theme.ds5.asset[assetColor]["100"]
            }),
            /*#__PURE__*/ jsxRuntime.jsx("path", {
                d: "M73.2045 74.6676H40.1674C38.7862 74.6676 37.4327 74.1921 36.3551 73.3274C35.2776 72.4636 34.5198 71.2454 34.2197 69.8972L27.418 39.293H83.44C84.1435 39.293 84.6752 39.9315 84.5478 40.6234L79.1959 69.679C78.6633 72.5696 76.1441 74.6676 73.2045 74.6676ZM40.7338 67.8695H72.6159L76.6276 46.092H35.893L40.7338 67.8695Z",
                fill: theme.ds5.asset[assetColor]["100"]
            }),
            /*#__PURE__*/ jsxRuntime.jsx("path", {
                d: "M70.1369 87.9983C73.7807 87.9983 76.7347 85.0444 76.7347 81.4005C76.7347 77.7567 73.7807 74.8027 70.1369 74.8027C66.493 74.8027 63.5391 77.7567 63.5391 81.4005C63.5391 85.0444 66.493 87.9983 70.1369 87.9983Z",
                fill: theme.ds5.asset[assetColor]["400"]
            }),
            /*#__PURE__*/ jsxRuntime.jsx("path", {
                d: "M43.2501 87.9983C46.894 87.9983 49.8479 85.0444 49.8479 81.4005C49.8479 77.7567 46.894 74.8027 43.2501 74.8027C39.6063 74.8027 36.6523 77.7567 36.6523 81.4005C36.6523 85.0444 39.6063 87.9983 43.2501 87.9983Z",
                fill: theme.ds5.asset[assetColor]["400"]
            }),
            /*#__PURE__*/ jsxRuntime.jsx("g", {
                clipPath: "url(#clip0_3427_22544)",
                children: /*#__PURE__*/ jsxRuntime.jsx("path", {
                    d: "M63.4632 55.1156C63.4632 55.1156 63.4632 55.1446 63.4632 55.1737C63.4632 55.4061 63.1073 60.2861 56.969 62.4937V59.4437L60.6757 55.4932C61.0019 55.1446 61.0019 54.5927 60.6164 54.2442C60.2605 53.9246 59.6971 53.9246 59.3413 54.3023L56.969 56.8585V54.2442C56.969 54.2442 56.969 54.2442 56.969 54.2151C57.2655 53.547 58.6889 50.9327 62.1881 50.9327C62.2177 50.9327 62.2474 50.9327 62.277 50.9327C63.6707 52.5594 63.4632 55.0865 63.4632 55.1156ZM55.1897 56.8585L52.7878 54.3023C52.4616 53.9537 51.8981 53.9246 51.5423 54.2442C51.1864 54.5637 51.1568 55.1446 51.483 55.4932L55.1897 59.4437V62.4647C49.0514 60.2571 48.7252 55.348 48.6955 55.1446C48.6955 55.1156 48.6955 55.1156 48.6955 55.0865C48.6955 55.0575 48.4583 52.5303 49.852 50.9037C49.8817 50.9037 49.9113 50.9037 49.9706 50.9037C53.4994 50.9037 54.8932 53.547 55.1897 54.1861C55.1897 54.1861 55.1897 54.1861 55.1897 54.2151V56.8585ZM63.3446 49.4222C63.1963 49.277 62.9887 49.1898 62.7811 49.1608C59.4302 48.9575 57.2358 50.6422 56.0793 52.2108C54.9228 50.6422 52.7581 48.9575 49.3775 49.1608C49.17 49.1608 48.9624 49.277 48.8141 49.4222C46.6494 51.5427 46.8866 54.9123 46.9163 55.2318C46.9163 55.4642 47.0645 57.1199 48.1617 59.037C49.1996 60.8671 51.394 63.278 55.7531 64.498C55.7828 64.498 55.8125 64.498 55.8125 64.5271C55.8421 64.5271 55.8421 64.5271 55.8718 64.5271C55.9014 64.5271 55.9014 64.5271 55.9311 64.5271C55.9607 64.5271 56.02 64.5271 56.0497 64.5271C56.0793 64.5271 56.1386 64.5271 56.1683 64.5271C56.198 64.5271 56.198 64.5271 56.2276 64.5271C56.2573 64.5271 56.2573 64.5271 56.2869 64.5271C56.3166 64.5271 56.3462 64.5271 56.3759 64.498C64.4714 62.2614 65.1831 55.8708 65.2128 55.2608C65.2424 55.0865 65.5389 51.6008 63.3446 49.4222Z",
                    fill: theme.ds5.asset.grey["700"]
                })
            }),
            /*#__PURE__*/ jsxRuntime.jsx("defs", {
                children: /*#__PURE__*/ jsxRuntime.jsx("clipPath", {
                    id: "clip0_3427_22544",
                    children: /*#__PURE__*/ jsxRuntime.jsx("rect", {
                        width: "18.682",
                        height: "15.6858",
                        fill: "white",
                        transform: "translate(46.7383 49.0156)"
                    })
                })
            })
        ]
    });
};

exports.Cart = Cart;
//# sourceMappingURL=Cart.cjs.map
